<template>
    <div class="mb-xl-10">
        <v-row class="justify-center align-center">
            <v-col cols="12" sm="8" md="7" lg="4">
                <span
                    class="
                        text-display-large text-left
                        font-weight-regular
                        text-typography1
                    "
                >
                    About ArupCompute
                </span>
            </v-col>
            <v-col cols="12" sm="8" md="7" lg="4" xl="3">
                <span class="text-left text-typography2 text-body-large">
                    Like YouTube puts videos in the cloud and makes them
                    accessible to all sorts of different devices, ArupCompute
                    takes code written by Arup designers, hosts it in the cloud,
                    and makes it accessible to all sorts of different tools -
                    such as Excel - scripts - such as python - and automated
                    systems - such as Total Design Automation.
                </span>
            </v-col>
            <v-col cols="0" xl="2"> </v-col>
        </v-row>
        <v-row class="justify-center align-center">
            <v-col cols="12" lg="9" class="mb-xl-10 mt-xl-10">
                <v-divider></v-divider>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="d-flex justify-center align-center">
                <div class="text-display-medium mb-4">
                    What can ArupCompute bring to your projects?
                </div>
            </v-col>
        </v-row>

        <v-row class="justify-center align-start">
            <v-col cols="12" sm="8" md="7" lg="3">
                <v-row>
                    <v-img
                        :src="manComputer"
                        class="my-3"
                        contain
                        height="25vh"
                    />
                </v-row>
                <v-row class="ma-sm-3 ma-lg-3 ma-xl-10">
                    <span
                        class="
                            text-body-large text-justify
                            font-weight-medium
                            mb-2
                        "
                    >
                        <v-icon color="secondary"
                            >mdi-numeric-1-circle-outline</v-icon
                        >

                        Instant insights
                    </span>
                    <span class="text-body-large text-start">
                        ArupCompute libraries run in the cloud giving everyone
                        instant access to all new features and bugfixes. No
                        installation, no configuration, no outdated copies.
                    </span>
                </v-row>
            </v-col>
            <v-col cols="12" sm="8" md="7" lg="3">
                <v-row>
                    <v-img
                        :src="ladyScreen"
                        class="my-3"
                        contain
                        height="25vh"
                    />
                </v-row>
                <v-row class="ma-sm-3 ma-lg-3 ma-xl-10">
                    <span
                        class="
                            text-body-large text-justify
                            font-weight-medium
                            mb-2
                        "
                    >
                        <v-icon color="secondary"
                            >mdi-numeric-2-circle-outline</v-icon
                        >
                        Secure data
                    </span>
                    <span class="text-body-large text-start">
                        Access to ArupCompute requires authentication. This
                        keeps Arup's intellectual property safe.
                    </span>
                </v-row>
            </v-col>
            <v-col cols="12" sm="8" md="7" lg="3">
                <v-row>
                    <v-img
                        :src="ladyChart"
                        class="my-3"
                        contain
                        height="25vh"
                    />
                </v-row>
                <v-row class="ma-sm-3 ma-lg-3 ma-xl-10">
                    <span
                        class="
                            text-body-large text-justify
                            font-weight-medium
                            mb-2
                        "
                    >
                        <v-icon color="secondary"
                            >mdi-numeric-3-circle-outline</v-icon
                        >
                        Innovate workflows
                    </span>
                    <span class="text-body-large text-start">
                        ArupCompute makes it easy for professional and
                        enthusiast developers to deploy their code to everyone.
                        Just write normal code, sprinkle on some meta-data, and
                        you are ready to deploy to the cloud!
                    </span>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script setup>
import manComputer from '../../assets/about/man_computer.svg'
import ladyScreen from '../../assets/about/lady_screen.svg'
import ladyChart from '../../assets/about/lady_chart.svg'
</script>
